(() => {
  if (!customElements.get("echo-slider")) {
    class echoSlider extends HTMLElement {
      constructor() {
        super();
      }

      removeConditionalSlides() {
        const slides = this.querySelectorAll(".swiper-slide");

        slides.forEach((slide) => {
          // Hide on mobile (<= 768px)
          if (window.innerWidth <= 768 && slide.querySelector(".hidden-mobile.echo-carousel-slide")) {
            slide.remove();
          }

          // Hide on desktop (>= 769px)
          if (window.innerWidth >= 769 && slide.querySelector(".hidden-desktop.echo-carousel-slide")) {
            slide.remove();
          }
        });
      }

      init() {
        // Remove slides first, before Swiper initializes
        this.removeConditionalSlides();

        const slider = this.querySelector(".swiper");
        const pagination = this.querySelector(".swiper-pagination");

        const buttonNext = this.querySelector(".slider-button-next");
        const buttonPrev = this.querySelector(".slider-button-prev");

        const slideAutoPlay = this.getAttribute("data-autoplay");
        const slidesPerView = this.getAttribute("data-slide-per-row");
        const spaceBetween = this.getAttribute("data-space-between");
        const showDots = this.getAttribute("data-show-dots");
        const showArrows = this.getAttribute("data-show-arrows");

        const mobileSlidesPerView = this.getAttribute(
          "data-mobile-slide-per-row"
        );

        const swiperOptions = {
          slidesPerView: mobileSlidesPerView,
          spaceBetween: spaceBetween,
          loop: false,
          breakpoints: {
            640: {
              slidesPerView: 2,
              spaceBetween: spaceBetween,
            },
            990: {
              slidesPerView: slidesPerView,
              spaceBetween: spaceBetween,
            },
          },
        };

        // Autoplay
        if (slideAutoPlay === "true") {
          swiperOptions.autoplay = {
            delay: 5000,
            disableOnInteraction: false,
          };
        }

        // Dots (pagination)
        if (showDots === "true") {
          swiperOptions.pagination = {
            el: pagination,
            clickable: true,
          };
        }

        // Arrows
        if (showArrows === "true") {
          swiperOptions.navigation = {
            nextEl: buttonNext,
            prevEl: buttonPrev,
          };
        }

        const swiper = new Swiper(slider, swiperOptions);
      }

      connectedCallback() {
        this.init();
      }
    }

    customElements.define("echo-slider", echoSlider);
  }
})();
